import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserFunctionDto } from '../../models/user/user-profile-dto';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/permissions`;

  constructor(private readonly http: HttpClient) {}

  findAll(): Observable<UserFunctionDto[]> {
    return this.http.get<UserFunctionDto[]>(`${this.endpoint}`);
  }
}
